import React, { useMemo } from "react";
import { TCText } from "../TCText/TCText";
import { observer } from "mobx-react-lite";
import { usePaymentStore } from "../../stores/StoreContext";
import { Player } from "../../apis/types";
import { useCourtBooking } from "../../context/courtBookingContext";

type props = {
  player: Player;
};

export const IncludePlayerForPayment: React.FC<props> = observer(
  ({ player }) => {
    const { userModel } = useCourtBooking();
    const paymentStore = usePaymentStore();

    const isCurrentUser = useMemo(
      () => player.userId.toString() === userModel?.userId.toString(),
      [player.userId, userModel?.userId]
    );
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          gap: 10,
          alignItems: "baseline",
        }}>
        <TCText
          style={{ fontWeight: 500, fontSize: 10, color: "black", width: 47 }}
          value={`Incl. payment`}
        />
        <div
          onClick={
            isCurrentUser
              ? undefined
              : () => {
                  paymentStore.togglePlayerToPay(player);
                }
          }
          style={{ alignSelf: "end", opacity: isCurrentUser ? 0.5 : 1 }}
          className={`select-indicator ${
            paymentStore.isPlayerIncludedForPayment(player) ? "selected" : ""
          }`}>
          {paymentStore.isPlayerIncludedForPayment(player) && <span>✓</span>}
        </div>
      </div>
    );
  }
);
